import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { RawTimeZone, rawTimeZones } from '@vvo/tzdb';
import { useTranslation } from 'react-i18next';

import { displayAddress, formatByMask } from 'src/common/helpers/common.helpers';
import PermissionCheck from 'src/components/permission-check';

import {
  ButtonContainer,
  CompanyInfoWrapper,
  ElementContainer,
  GridContainer,
  GridElement,
} from './company-info.styles';

const CompanyInfo = ({
  onClickEdit,
  companyData,
}: {
  onClickEdit: () => void;
  companyData: any;
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const timezone: RawTimeZone | undefined = rawTimeZones.find(
    ({ rawOffsetInMinutes }: RawTimeZone) => rawOffsetInMinutes === companyData.timezone
  );

  return (
    <CompanyInfoWrapper>
      <GridContainer>
        <GridElement>
          <ElementContainer>
            <Typography weight="bold">{t('settings:company.labels.companyName')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {companyData.name}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">
              {t('settings:company.labels.companyPhoneNumber')}:
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {formatByMask(companyData.phoneNumber, '+## ### ### #######') || '-'}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">
              {t('settings:company.labels.companyEmailAddress')}:
            </Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {companyData.email || '-'}
            </Typography>
          </ElementContainer>
        </GridElement>
        <GridElement>
          <ElementContainer>
            <Typography weight="bold">{t('settings:company.labels.timezone')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {timezone?.rawFormat || '-'}
            </Typography>
          </ElementContainer>
          <ElementContainer>
            <Typography weight="bold">{t('settings:company.labels.businessAddress')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {displayAddress(companyData)}
            </Typography>
          </ElementContainer>
        </GridElement>
      </GridContainer>
      <ButtonContainer>
        <PermissionCheck
          action={PERMISSION_ACTIONS.update}
          permission={PLATFORM_PERMISSIONS.companyManagement}
        >
          <Button
            type="primary"
            ghost
            onClick={onClickEdit}
            icon={ICONS.editAlt}
            iconColor={PLATFORM_THEME_COLORS.primary.blue}
          >
            {t('common:buttons.edit')}
          </Button>
        </PermissionCheck>
      </ButtonContainer>
    </CompanyInfoWrapper>
  );
};

export default CompanyInfo;
